<style scoped>

/* Live Feed CSS */
a.txtlink:hover{
    text-decoration: none;
}

pre.code-pre{
    background: #f3f3f3;
    max-height: 300px;
}

.meta {
    color: #777;
    font-size: .85em;
}

.meta-bit {
    color: #333;
    font-weight: bold;
}

>>>span.badge.nohover{
    font-size: 10px;
    text-align: center;
    min-height: 1.1rem;
}

span.badge.nohover.badge-light.badge-pill{
    background-color: #d1e3ff !important;
}

span.badge.nohover.yara-pill.badge-secondary.badge-pill{
    background-color: #7400c6 !important;
}

.table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
}
.badge.badge-primary.badge-pill{
    font-size: .7rem;
    background-color: #bfbfbf;
}
.badge.badge-primary.badge-pill:hover{
    /*background-color: #0062cc;*/
    background-color: #bfbfbf;
    cursor: pointer;
}

div#lf-tip{
/*    border-bottom-color: #000 !important;
    border-bottom-style: solid;
    border-bottom-width: 4px;
    border-top-color: #000 !important;
    border-top-style: solid;
    border-top-width: 4px;
    color: #000;
    text-align: center;
    background-color: #fff !important;
    border-radius: 0.25rem;*/
}
#lf-info.fa.fa-info-circle:hover{
    cursor: pointer;
}
span.badge.nohover.autoit-pill.badge-secondary.badge-pill{
    background-color: #5c82ac;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.downloader-pill.badge-secondary.badge-pill{
    background-color: #28a745;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.malpedia-pill.badge-secondary.badge-pill{
    background-color: #ff6a23;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.deepmatch-pill.badge-secondary.badge-pill{
    background-color: #701fb9;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.children-pill.badge-secondary.badge-pill{
    background-color: #bfbfbf;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.nochildren-pill.badge-secondary.badge-pill{
    background-color: #f1d543;
    font-weight: normal;
    font-size: 10px;
}

>>>thead{
    line-height: 1;
    font-size: 0.9rem;
}
>>>tbody{
    line-height: 1;
    font-size: 0.9rem;
}
h1#info-page{
    font-size:45px;
    font-weight:300;
    height:54px;
    line-height:54px;
}
.vl {
  border-left: 1px solid;
  border-left-color: rgba(0, 0, 0, 0.125);
  height: 50px;
}
a#bt-scroll.btn.btn-secondary.btn-block{
    min-width: 1120px;
    background-color: #ffffff;
    border-color: #ffffff;
    color: #bcbec0;
}
a#bt-scroll.btn.btn-secondary.btn-block:hover{
    background-color: #fdfdff;
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll.btn.btn-secondary.btn-block:focus{
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block{
    min-width: 1120px;
    background-color: #ffffff;
    border-color: #ffffff;
    color: #bcbec0;
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block:hover{
    background-color: #ffffff;
    cursor: default;
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block:focus{
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
.blinking{
    animation:blinkingText 2s infinite;
}
@keyframes blinkingText{
    0%{     color: rgba(188, 190, 192, 0.1);  }
    5%{     color: rgba(188, 190, 192, 0.2);  }
    10%{    color: rgba(188, 190, 192, 0.3);  }
    15%{    color: rgba(188, 190, 192, 0.4);  }
    20%{    color: rgba(188, 190, 192, 0.5);  }
    25%{     color: rgba(188, 190, 192, 0.6);  }
    30%{   color: rgba(188, 190, 192, 0.7);    }
    35%{   color: rgba(188, 190, 192, 0.8);    }
    40%{   color: rgba(188, 190, 192, 0.9);    }
    45%{   color: rgba(188, 190, 192, 1);    }
    50%{   color: rgba(188, 190, 192, 0.9);    }
    55%{   color: rgba(188, 190, 192, 0.8);    }
    60%{   color: rgba(188, 190, 192, 0.7);    }
    65%{   color: rgba(188, 190, 192, 0.6);    }
    70%{   color: rgba(188, 190, 192, 0.5);    }
    75%{   color: rgba(188, 190, 192, 0.4);    }
    80%{   color: rgba(188, 190, 192, 0.3);    }
    85%{   color: rgba(188, 190, 192, 0.2);    }
    90%{   color: rgba(188, 190, 192, 0.1);    }
    95%{   color: rgba(188, 190, 192, 0);    }
    100%{   color: rgba(188, 190, 192, 0);    }
}
button#hash-search.btn.btn-outline-secondary.btn-md:focus{
    outline: -webkit-focus-ring-color auto 0px!important;
    border-color: inherit !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}
</style>

<template>
<div class="container">
    <div class="row">
        <div class="col-sm-6">
            <h1 id="info-page">Search
                <template v-if="searchLoading">
                    <small style="color:#b4bcc2;font-size:0.9rem;">
                        <b-spinner small label="Loading..."></b-spinner>
                    </small>
                </template>
            </h1>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12">
            <b-card
                no-body
                title=""
                img-top
                id="upload-settings"
                class="mb-2"
                style="max-width: 70rem;min-width: 70rem;"
            >
                <b-card-body style="padding-top: 60px;padding-bottom: 60px;">
                    <b-card-text>
                        <b-row>
                            <b-col >
                                <b-row>
                                    <b-col cols="1">
                                    </b-col>
                                    <b-col cols="9">
                                        <b-form-input v-model="inputHash" @keydown.enter.native="searchByHash(inputHash)" placeholder="Enter parent SHA256 hash"></b-form-input>
                                    </b-col>
                                    <b-col cols="2">
                                        <b-button id="hash-search" size="md" variant="outline-secondary" v-on:click="searchByHash(inputHash)" ref="button">
                                        Search <i class="fa fa-search"></i>
                                    </b-button>
                                    </b-col>
                                </b-row>
                                <template v-if='Object.keys(accessData).length && 
                                                !(
                                                accessData.roles.includes("feed") ||
                                                accessData.roles.includes("admin") 
                                                )'>
                                    <br>
                                    <b-row>
                                        <b-col cols="1">
                                        </b-col>
                                        <b-col cols="9">
                                            <div style="font-size: 80%; font-weight: 400;color: #777;">
                                                Your plan only allows searching across your own submissions. 
                                                For full search access to our entire sample corpus please consult our available <a id="link" href="/plans">plans</a>.
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                        </b-button>
                                        </b-col>
                                    </b-row>
                                </template>
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-card-body>
            </b-card>
        </div>
    </div>
    <template v-if='Object.keys(searchResults).length'>
        <div class="row">
            <div class="col-sm-10">
                <table class="table table-hover" style="max-width: 70rem;min-width: 70rem;">
                  <thead>
                    <tr>
                      <th scope="col">Submitted</th>
                      <th scope="col">Sample</th>
                      <th scope="col">Children</th>
<!--                       <th scope="col">Tags</th> -->
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="meta" v-for="(sample, index) in searchResults" :key="index" >
                        <td style="line-height: 1.5;">
                            <template v-if='sample.created'>
                                {{ Math.trunc(sample.created) | moment("DD/MM/YYYY")  }}
                                <br>
                                {{ Math.trunc(sample.created) | moment("HH:mm:ss")  }}
                            </template>
                        </td>
                        <td><a class="txtlink"  target="_blank" :href="'/results/'+sample.submission_id"><b class="txtlink">{{ sample.sha256 }}</b></a></td>
                        <td>
                            <template v-if="sample.children.length == 0 &&
                                            !sample.downloader &&
                                            sample.malwareid &&
                                            !Object.keys(sample.malwareid).length">
                                <b-badge pill style="pointer-events:none" class="nohover nochildren-pill"><b>{{sample.children.length}}</b></b-badge>
                            </template>
                            <template v-else>
                                <b-badge pill style="pointer-events:none" class="nohover children-pill"><b>{{sample.children.length}}</b></b-badge>
                            </template>
                        </td>
<!--                         <td style="line-height: 1.5;">
                            <template v-if="sample.autoit">
                                <b-badge pill style="pointer-events:none" v-bind:key="sample.autoit.id" class="nohover autoit-pill"><b>AutoIt</b></b-badge>
                            </template>
                            <template v-if="sample.downloader">
                                <b-badge pill style="pointer-events:none" v-bind:key="sample.downloader.id" class="nohover downloader-pill"><b>Network Dropper</b></b-badge>
                            </template>
                            <template v-for="malwareidHit in sample.malwareid">
                                <template v-if="malwareidHit.type =='malpedia'">
                                    <b-badge pill style="pointer-events:none" v-bind:key="malwareidHit.id" class="nohover malpedia-pill"><b>{{malwareidHit.match}}</b></b-badge>
                                </template>
                            </template>
                            <template v-for="deepMatchHit in sample.deepmatch">
                                <b-badge pill style="pointer-events:none" v-bind:key="deepMatchHit.id"  class="nohover deepmatch-pill"><b>{{deepMatchHit.label}}</b></b-badge>
                            </template>
                        </td> -->
                        <td>
                            <b-badge variant="primary"
                                v-on:click="bulkDownload(sample.submission_id)"
                                pill
                                v-b-popover.hover.topright.html="'Feature available soon'"
                                >
                                 Bulk Download <i class="fa fa-cloud-download"></i>
                            </b-badge>
                        </td>
                    </tr>
                  </tbody>
                </table>
            </div>
        </div>
    </template>
            


</div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['auth', 'authenticated'],
    data() {
        return {
            // For controlling the timer and status display
            searchResults: [],
            accessData: {},
            searchLoading: false,
            inputHash: "",
            // my_timer: 0
        };
    },
    beforeCreate() {
        document.body.className = 'none';
    },
    metaInfo() {
        return {
            title: 'UnpacMe Live Feed',
            meta: [{ name: 'description', content: 'UnpacMe is an automated malware unpacking service. We provide malware analysis at Internet scale. Free for non-commercial use.' },
                { name: 'keywords', content: 'unpacking,unpacme,unpakme,unpackme,malware,malware analysis,analysis,automation,sandbox,oalabs,openanalysis,open analysis' }],
        };
    },
    notifications: {
        showInfoMsg: {
            type: 'info',
            title: 'Hey you',
            message: 'Here is some info for you',
        },
        showErrorMsg: {
            type: 'error',
            title: 'ERROR',
            message: 'That\'s the error',
            timeout: 30000,
        },
    },
    methods: {
        getAccess() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/access';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.accessData = res.data;
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                });
        },
        getAuthBearer() {
            this.accessToken = localStorage.getItem('access_token') || null;
            return `Bearer ${this.accessToken}`;
        },
        isMobile() {
            if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            // ipad is a full browser
            // navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
                console.log('is mobile');
                return true;
            }
            console.log('not mobile');
            return false;
        },
        searchByHash(sha256Hash) {
            // Do some light validation 
            if ((sha256Hash.trim() === "") || sha256Hash.trim().length != 64 ){
                this.showErrorMsg({ title: 'Invalid hash', message: '<br>Please enter a valid SHA256 hash.' });
                return
            }
            this.feedLoading = true;
            const tempBearer = this.getAuthBearer();
            const searchUrl = `https://api.unpac.me/api/v1/private/search/hash/${sha256Hash.trim()}`;
            axios.get(searchUrl, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    // Sort the submissions from newest to oldest
                    var byDateResults = res.data.results.slice(0);
                    byDateResults.sort(function(a,b) {
                        return Math.trunc(b.created) - Math.trunc(a.created) ;
                    });
                    this.searchResults = byDateResults;
                    this.searchLoading = false;
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                    this.searchLoading = false;
                    if (error.response.status === 404) {
                        this.showInfoMsg({ title: 'Sample Not Found', message: "<br>We don't have a record for that hash." });
                    }
                    else {
                        this.showErrorMsg({ title: 'Invalid hash', message: '<br>Please enter a valid SHA256 hash.' });
                    }
                    
                });

        },
        bulkDownload(sampleLink) {
            // const tempBearer = this.getAuthBearer();
            // axios({
            //     url: `https://api.unpac.me/api/v1/private/download/${sampleLink}`,
            //     headers: { Authorization: tempBearer },
            //     method: 'GET',
            //     responseType: 'blob', // important
            // }).then((response) => {
            //     const url = window.URL.createObjectURL(response.data);
            //     const link = document.createElement('a');
            //     link.href = url;
            //     link.setAttribute('download', `${sampleLink}.bin`); // or any other extension
            //     document.body.appendChild(link);
            //     link.click();
            // })
            //     .catch((error) => {
            //         if (error.response.status === 401) {
            //             this.showErrorMsg({ title: 'Download Not Authorized', message: '<br>Downloads are only permitted for the results of your own submissions. Please submit the parent for analysis.' });
            //         } else if (error.response.status === 404) {
            //             this.showErrorMsg({ title: 'Sample Not Found', message: '<br>Download is not available for this sample.' });
            //         } else {
            //             this.showErrorMsg({ title: 'Download Error', message: '<br>We are currently experiencing some technical difficulties with the download.' });
            //         }
            //     });
        },
        clickGoTo(sample) {
            // window.location.href = "/results/"+sample.id;
            window.open(
                `/results/${sample.id}`,
                '_blank', // <- This is what makes it open in a new window.
            );
        },
    },
    created() {
        if (this.authenticated) {
            this.getAccess();
        }
        // this.my_timer = setInterval(this.getFeed, 90000)
    },
    beforeDestroy() {
        // Clear the timer
        // clearInterval(this.my_timer)
    },
};
</script>




// WEBPACK FOOTER //
// src/components/Search.vue